import React from "react";
import { ThemeProvider } from "styled-components";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Routes as Router, Route } from "react-router-dom";
import HomePage from "./pages/Home";
import NewPage from "./pages/New";
import CompaniesPage from "./pages/Companies";
import StorePage from "./pages/Store";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import SaleTerminatePage from "./pages/SaleTerminate";
import OrderPage from "./pages/Order";
import CartPage from "./pages/Cart";
import Payments from "./pages/Payments";
import { makeTheme } from "./themes";
import OrderViewer from "./pages/OrderViewer";
import { CartProvider } from "./hooks/useCart";
import PageTransition from "./components/ui/PageTransition";
import StoreThemeProvider from "./components/StoreThemeProvider";
import DocumentTitle from "./components/DocumentTitle";

const AdminRoutes = React.lazy(() => import("./pages/Admin"));

const { styled: themeStyled, mui: themeMui } = makeTheme();

/** Envolve cada página com a animação de entrada de rota. */
const page = (element: React.ReactNode) => (
  <PageTransition>{element}</PageTransition>
);

/** Página da jornada de compra: tema da loja (por :suffix) + animação de rota. */
const storePage = (element: React.ReactNode) => (
  <StoreThemeProvider>
    <PageTransition>{element}</PageTransition>
  </StoreThemeProvider>
);

function App() {
  return (
    <ThemeProvider theme={themeStyled}>
      <MuiThemeProvider theme={themeMui}>
        <CartProvider>
          <BrowserRouter>
            <DocumentTitle />
            <Router>
              <Route index path="/" element={page(<HomePage />)} />
              <Route path="/new" element={page(<NewPage />)} />
              <Route path="/store" element={page(<CompaniesPage />)} />
              <Route
                path="/store/:companyId/group/:groupId/products"
                element={page(<NewPage />)}
              />
              <Route
                path="/store/:suffix/table/:tableId/cart"
                element={storePage(<CartPage />)}
              />
              <Route
                path="/store/:suffix/table/:tableId"
                element={storePage(<StorePage />)}
              />
              <Route path="/store/:suffix/cart" element={storePage(<CartPage />)} />
              <Route
                path="/store/:suffix/payments"
                element={storePage(<Payments />)}
              />
              <Route path="/store/:suffix" element={storePage(<StorePage />)} />
              <Route
                path="/terminate/:saleId"
                element={page(<SaleTerminatePage />)}
              />
              <Route path="/order/:saleId" element={page(<OrderPage />)} />
              <Route path="/orders" element={page(<OrderViewer />)} />
              <Route path="/orders/:storeId" element={page(<OrderViewer />)} />
              <Route
                path="/admin/*"
                element={
                  <React.Suspense fallback={null}>
                    <AdminRoutes />
                  </React.Suspense>
                }
              />
              <Route
                path="/menu/:suffix"
                element={storePage(<StorePage styleSale="menu" />)}
              />
            </Router>
          </BrowserRouter>
          <ToastContainer />
        </CartProvider>
      </MuiThemeProvider>
    </ThemeProvider>
  );
}

export default App;